import React, { Component } from 'react'
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages';
import SwalServices from '../../services/swalServices/SwalServices';
import CommonServices from '../../services/axioServices/apiServices/CommonServices';
import ItemMasterServices from '../../services/axioServices/apiServices/ItemMasterServices';
import Table from '../../components/common/Table';
import QCServices from '../../services/axioServices/apiServices/QCServices';
import { Navigate } from 'react-router-dom';
import { encryptAES } from '../../utils/Encryption';
import TextInput from '../../components/common/TextInput';

export default class PackingMaterialSampleEntry extends Component {
  constructor(props) {
    super(props);
    this.qcServices = new QCServices();
    this.itemMasterServices = new ItemMasterServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      openModel: false,
      route: null,
      partyList: [],
      materialList: [],
      partyObject: {
        partyId: ""
      },
      filterObject: {
        globalSearch: "",
        partyId: "",
        materialId: ""
      },
      tableData: [],
      columns: [
        { field: 'refNo', header: 'Ref. No' },
        { field: 'grnNo', header: 'GRN No' },
        { field: 'refDate', header: 'Ref. Date' },
        { field: 'batchNo', header: 'Batch No' },
        { field: 'partyName', header: 'Party Name' },
        { field: 'materialName', header: 'Material Name' },
        { field: 'action', header: 'Action', body: this.actionTemplate, sortable: false }
      ],
    }
  }

  componentDidMount = () => {
    this.getAllPackingMaterialSampleEntry()
  }

  getAllPackingMaterialSampleEntry = () => {
    let filterObject = this.state.filterObject
    let request = [filterObject.globalSearch, filterObject.materialId, filterObject.partyId]
    this.qcServices.getAllPackingMaterialSampleEntry(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        this.setState({ tableData: res }, () => {
          this.getAllPartyDropdown()
        });
      } else {
        this.SwalServices.Error(response.Message);
        this.getAllPartyDropdown()
      }
    });
  };

  getAllPartyDropdown = () => {
    this.commonServices.getAllPartyDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.partyName,
          value: item._id,
        }));
        this.setState({ partyList: dropdownItems }, () => {
          this.getAllPackingMaterialDropdown()
        });
      } else {
        this.SwalServices.Error(response.Message);
        this.getAllPackingMaterialDropdown()
      }
    });
  };

  getAllPackingMaterialDropdown = () => {
    this.commonServices.getAllPackingMaterialDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.pmName,
          value: item._id,
        }));
        this.setState({ materialList: dropdownItems });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  actionTemplate = (rowData) => {
    return (
      <div className="flex gap-2">
        <button
          className="search-btn w-[28px] h-[28px] bg-blue text-white rounded"
          onClick={() => this.handleEdit(rowData.sampleEntryPMId)}
        >
          <FontAwesomeIcon icon={faPen} className='w-[14px] h-[14px]' />
        </button>
        <button
          className="cancel-btn w-[28px] h-[28px] bg-red-500 text-white rounded hover:bg-red-600"
          onClick={() => this.handleDelete(rowData.sampleEntryPMId)}
        >
          <FontAwesomeIcon icon={faTrash} className='w-[14px] h-[14px]' />
        </button>
      </div>
    );
  };

  handleEdit = (sampleEntryPMId) => {
    this.setState({ route: '/PackingMaterialSampleEntryDetails?id=' + encryptAES(sampleEntryPMId) })
  }

  handleDelete = (sampleEntryPMId) => {
    this.SwalServices.Confirm(
      "",
      ``,
      CommonSuccessMessages.Yes_Text,
      CommonSuccessMessages.No_Text,
      `Are you sure you want to delete ?`
    ).then((response) => {
      if (response === true) {
        this.qcServices.deletePackingMaterialSampleEntryById(sampleEntryPMId).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.SwalServices.Success(response.Message);
            this.getAllPackingMaterialSampleEntry()
          } else {
            this.SwalServices.Error(response.Message);
          }
        });
      }
    });
  }

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.filterObject;
    details[name] = value.toUpperCase();
    this.setState({ filterObject: details }, () => {
      this.getAllPackingMaterialSampleEntry()
    });
  };

  setFilterParametersForItemName = (selected, name) => {
    if (selected.value) {
      let filterObject = this.state.filterObject;
      filterObject[name] = selected.value;
      this.setState({ filterObject: filterObject }, () => {
        this.getAllPackingMaterialSampleEntry()
      });
    }
  }

  resetFilterObject = () => {
    let filterObject = this.state.filterObject
    filterObject.globalSearch = ''
    filterObject.materialId = ''
    filterObject.partyId = ''
    this.setState({ filterObject: filterObject }, () => {
      this.getAllPackingMaterialSampleEntry()
    })
  }

  render() {
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }
    return (
      <div className='raw-material-sample'>
        <div className="item-search">
          <div className="item-grp grid grid-cols-4 gap-2.5">
            <div className="item-search-box col-span-1">
              <label>Search</label>
              <TextInput
                className="inputFocus"
                type="text"
                id="globalSearch"
                name="globalSearch"
                value={this.state.filterObject.globalSearch}
                onChange={(event) => this.handleChange(event, "globalSearch")}
              />
            </div>
            <div className="item-search-box col-span-1">
              <label>Material Name</label>
              <MultiSelectDropdown
                drpIdentity="materialId"
                options={this.state.materialList}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                onChange={(selected) => this.setFilterParametersForItemName(selected, "materialId")}
                allowSelectAll={false}
                value={this.state.materialList.filter((party) => party.value === this.state.filterObject.materialId)}
              />
            </div>
            <div className="item-search-box col-span-1">
              <label>Party Name</label>
              <MultiSelectDropdown
                drpIdentity="partyId"
                options={this.state.partyList}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                onChange={(selected) => this.setFilterParametersForItemName(selected, "partyId")}
                allowSelectAll={false}
                value={this.state.partyList.filter((party) => party.value === this.state.filterObject.partyId)}
              />
            </div>
            <div className="item-search-box flex items-center gap-2.5 col-span-1">
              <button
                className='cancel-btn w-fit h-fit mt-5'
                onClick={() => this.resetFilterObject()}
              >
                Reset
              </button>
              <button
                className='add-btn w-fit h-fit mt-5'
                onClick={() => { this.setState({ route: '/PackingMaterialSampleEntryDetails' }) }}
              >
                Add
              </button>
            </div>
          </div>
        </div>
        <Table
          tableData={this.state.tableData}
          columns={this.state.columns}
          scrollHeight="calc(100dvh - 190px)"
        />
      </div>
    )
  }
}
